import McElement from "https://gipys.it/cdn/shop/t/11/assets/mc-element.js?v=90842969451512648831772093217";
class McHeader extends McElement {
  constructor() {
    super(...arguments);
    this._canBeTransparent = true;
    this.init = () => {
      if (this.dataset.transparent == void 0 || this.dataset.normal == void 0) return;
      this.log("Inizializzazione header");
      this._onScroll();
      window.addEventListener("scroll", this._onScroll.bind(this));
      this.addEventListener("mouseover", this._mouseOver.bind(this));
      this.addEventListener("mouseleave", this._mouseLeave.bind(this));
    };
    this._mouseOver = () => {
      this.log("Mouse over");
      this._canBeTransparent = false;
      this._setNormal();
    };
    this._mouseLeave = () => {
      this.log("Mouse leave");
      this._canBeTransparent = true;
      this._onScroll();
    };
    this._onScroll = () => {
      const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--topbar").trim().replace("px", "")) || 0;
      this.log("Scroll Y: " + window.scrollY + " Offset: " + offset);
      if (window.scrollY > offset)
        this._setNormal();
      else
        this._setTransparent();
    };
    this._setTransparent = () => {
      var _a, _b;
      if (!this._canBeTransparent) return;
      this.log("Impostazione header trasparente");
      const transparentClasses = ((_a = this.dataset.transparent) == null ? void 0 : _a.split(" ")) || [];
      const normalClasses = ((_b = this.dataset.normal) == null ? void 0 : _b.split(" ")) || [];
      this._setClasses(transparentClasses, normalClasses);
    };
    this._setNormal = () => {
      var _a, _b;
      this.log("Impostazione header normale");
      const transparentClasses = ((_a = this.dataset.transparent) == null ? void 0 : _a.split(" ")) || [];
      const normalClasses = ((_b = this.dataset.normal) == null ? void 0 : _b.split(" ")) || [];
      this._setClasses(normalClasses, transparentClasses);
    };
    this._setClasses = (toadd, toremove) => {
      toadd == null ? void 0 : toadd.forEach((c) => {
        if (!this.classList.contains(c))
          this.classList.add(c);
      });
      toremove == null ? void 0 : toremove.forEach((c) => {
        if (this.classList.contains(c))
          this.classList.remove(c);
      });
    };
    this.setCanBeTransparent = (can) => {
      this._canBeTransparent = can;
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.init();
  }
}
if (!customElements.get("mc-header"))
  customElements.define("mc-header", McHeader);
var mc_header_default = McHeader;
export {
  mc_header_default as default
};
